<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
          </li>
          <li class="nav-item dropdown col-1-dropdown">
            <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
            <div class="dropdown-menu" style="width: 200px;">
              <ul>
                <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                  <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                </li>
                <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                  <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
                <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                  <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
          </li>
           <li class="nav-item signup-btn">
          <a class="nav-link button" data-toggle="modal" routerLink="/login">Start for free</a>
          </li>
          <li class="nav-item login-btn">
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<section class="community-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h2>Profile-driven insights <br>and reward incentives <span class="freelaner-txt">User Profiling</span></h2>
        <p>Offering customised rewards encourages greater interaction and loyalty, leading to improved products and services.</p>
        <div class="btn-wrapper">
          <a class="button enterprise-buy-now" style="background: #000000; color: #ffffff;" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a>
          <a class="button light-blue-btn" style="color: #2d7cff;" routerLink="/login">Start for free</a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="feature-custom-section profiling-blue-sec">
	<div class="container">
		<div class="row">
      <div class="col-sm-6">
        <div class="img-box" style="text-align: left;">
      		<img src="assets/img/user_team.png">
        </div>
      </div>
      <div class="col-sm-1">
      </div>
			<div class="col-sm-5 align-vertical_center">
				<div class="inner-content">
          <h2>Team Rewards: Earn rank badges</h2>
          <p>Celebrate your achievements in task completion and receive rewards on a monthly basis or upon completing tasks. As your team completes milestones, they collect badges that encourage continuous improvement and competition.</p>
          <ul>
            <li>Monthly rank badges based on performance.</li>
            <li>Badges will be displayed on the user's profile alongside their display picture.</li>
          </ul>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="feature-custom-section" style="background-color: #ffffff;">
	<div class="container">
		<div class="row">
      <div class="col-sm-5 align-vertical_center">
				<div class="inner-content">
          <h2>User social profiling</h2>
          <p>Users can enhance their profiles by adding social media links, fostering greater engagement and interaction when sharing publicly. These links allow others to connect more easily, driving traffic to their social platforms and encouraging community building. <br><br>By showcasing their social presence, users can cultivate a more vibrant online persona, attracting followers and collaborations. This feature not only amplifies visibility but also promotes networking opportunities within the platform.</p>

				</div>
			</div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6">
        <div class="img-box" style="text-align: right;">
      		<img src="assets/img/user_social.png">
        </div>
      </div>
		</div>
	</div>
</section>

<section class="feature-custom-section profiling-blue-sec">
	<div class="container">
		<div class="row">
      <div class="col-sm-6">
        <div class="img-box" style="text-align: left;">
      		<img src="assets/img/go_public.png">
        </div>
      </div>
      <div class="col-sm-1">
      </div>
			<div class="col-sm-5 align-vertical_center">
				<div class="inner-content">
          <h2>Go public</h2>
          <p>Users can generate a public link to their profile, allowing them to share it with anyone for increased visibility. This feature helps users showcase their work, gain more project views, and foster potential collaborations, broadening their reach and professional network.</p>
          <ul>
            <li>Generate a Go public link.</li>
            <li>Share your projects and social links with anyone.</li>
          </ul>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="feature-custom-section" style="background: #ffffff;">
	<div class="container">
		<div class="row">
      <div class="col-sm-5 align-vertical_center">
				<div class="inner-content">
          <h2>User information</h2>
          <p>Users can enhance their profiles by including personal data, such as their designation and other relevant details. This transparency allows fellow users to better understand their expertise and professional background. <br><br>By sharing this information, users can foster connections, increase engagement, and open up opportunities for collaboration within the community.</p>
				</div>
			</div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6">
        <div class="img-box" style="text-align: right;">
      		<img src="assets/img/user_info.png">
        </div>
      </div>
		</div>
	</div>
</section>

<section class="designed-area comparison-feedbacks" style="padding-top: 0px;">
  <div class="container">
    <h3>What our customers are saying</h3>
    <div class="row">
      <div class="col-md-4">
        <div class="review-box back-color">
          <div class="review-icon-box">

          </div>
          <p>Crafttor is sleek and modern, making it easy to navigate and find what I need quickly.</p>
          <div class="review-img-box">
            <hr class="hr-border">
            <div class="review-img">
              <img src="assets/img/snew.jpeg" alt="">
              <p>Souradeep Paul <br>anthillcreations.org</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="review-box back-color review-top-view">
          <div class="review-icon-box-1">

          </div>
          <p>The migration process to Crafttor was relatively smooth, thanks to the helpful guidance and support provided by the Crafttor team.</p>
          <div class="review-img-box">
            <hr class="hr-border">
            <div class="review-img">
              <img src="assets/img/prnew.jpeg" alt="">
              <p>Sahil Pruthi <br>Livofy</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="review-box back-color review-top-view">
          <div class="review-icon-box-2">

          </div>
          <p>With Crafttor, we finally get rid of wasting too many hours working with other cloud systems.</p>
          <div class="review-img-box">
            <hr class="hr-border">
            <div class="review-img">
              <img src="assets/img/sanew.jpeg" alt="">
              <p>Sanchit Garg <br>innerfit.me</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="compareplan-section">
	<div class="container">
		<h3>The way you go smarter not harder</h3>
		<div class="row">
			<div class="col-md-1">
			</div>
			<div class="col-md-5">
				<div class="blog-box">
          <img src="https://crafttor-admin.s3.amazonaws.com/admin_images/blogs/iso-all.png">
					<h4 class="">Iso All Plugin for Crafttor</h4>
					<p class="blog-desc">The Iso All plugin is a powerful Figma tool designed to streamline designers' workflow and enhance creative outputs. The plugin simplifies your tasks by converting layers and elements into isometric views with just a few clicks. Let's explore how Iso All can improve efficiency in your design projects...</p>
          <span>
            <a class="know-more" href="https://crafttor.com/blog/iso-all-plugin-for-crafttor" target="_blank">Know more
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </a>
          </span>
				</div>
			</div>
			<div class="col-md-5">
				<div class="blog-box">
          <img style="height: 235px;" src="https://crafttor-admin.s3.amazonaws.com/admin_images/blogs/translate.png">
          <h4 class="">Unlock Global Creativity with Translate AI Plugin</h4>
					<p class="blog-desc">In today’s globalised world, collaboration between teams has become the norm. However, different languages can always create barriers and that’s where Crafttor’s Translate AI plugin steps in, offering a seamless solution for designers...</p>
          <span>
            <a class="know-more" href="https://crafttor.com/blog/unlock-global-creativity-with-translate-ai-plugin" target="_blank">Know more
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </a>
          </span>
				</div>
			</div>
			<div class="col-md-1">

			</div>
		</div>
	</div>
</section>

<section class="company-section">
  <div class="sec-title">
    <h1>Love shown by designers from</h1>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-sm-1">
      </div>
      <div class="col-sm-2">
        <img src="assets/img/airtel.svg" alt="">
      </div>
      <div class="col-sm-3">
        <img src="assets/img/licious.svg" alt="">
      </div>
      <div class="col-sm-3">
        <img src="assets/img/byju.svg" alt="">
      </div>
      <div class="col-sm-2">
        <img src="assets/img/wheels.svg" alt="">
      </div>
      <div class="col-sm-1">
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-sm-1">

      </div>
      <div class="col-sm-2">
        <img src="assets/img/deloitte.svg" alt="">
      </div>
      <div class="col-sm-3">
        <img src="assets/img/flip.svg" alt="">
      </div>
      <div class="col-sm-3">
        <img src="assets/img/innovaccer.svg" alt="">
      </div>
      <div class="col-sm-2">
        <img src="assets/img/thoughtworks.svg" alt="">
      </div>
      <div class="col-sm-1">

      </div>
    </div>
  </div>
</section>

<section class="community-bottom-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h1>Try Crafttor Workspace for free</h1>
        <p>Ready to streamline your workflow? Start crafting your workspace now.</p>
        <div class="btn-wrapper">
          <a class="button enterprise-buy-now" style="color: #000000;" (click)="openLetsTalkDialog(letsTalk)">Connect with us</a>

          <a class="button enterprise-buy-now review-top-btn" style="background: #000000; color: #ffffff;" (click)="goToProfile()">Go to Profile</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="coulmn-1">
  				<img src="assets/img/logo.svg">
  				<p>Digital assets management</p>
  				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
  			</div>
      </div>
      <!-- 3 -->
      <div class="col-sm-2">
        <h5>Products</h5>
        <ul class="menu">
          <li><a routerLink="/home">Workspace</a></li>
          <li><a (click)="openMarketplace()">Marketplace</a></li>
          <li><a routerLink="/features">Features</a></li>
          <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
          <li><a routerLink="/effective-search">Effective search</a></li>

        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Plugins</h5>
        <ul class="menu">
          <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
          <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
          <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
          <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
          <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
          <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Solutions</h5>
        <ul class="menu">
          <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
          <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
          <li><a routerLink="/box-alternative">Box alternative</a></li>
          <li><a routerLink="/content-library">Content library</a></li>
          <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Features</h5>
        <ul class="menu">
          <li><a routerLink="/features/tagging">Tagging</a></li>
          <li><a routerLink="/features/sharing">Sharing</a></li>
          <li><a routerLink="/features/versioning">Versioning</a></li>
          <li><a routerLink="/features/collaboration">Collaboration</a></li>
          <li><a routerLink="/features/integration">Integration</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Company</h5>
        <ul class="menu">
          <li><a routerLink="/about-workspace">About Workspace</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms">Terms & Conditions</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/feedbacks">Feedback</a></li>
          <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
          <li><a routerLink="/our-mission">Our mission</a></li>
          <li><a routerLink="/partner-with-us">Partner with us</a></li>
        </ul>
      </div>

      <div class="col-sm-3 all-social-icons">
        <h5>Socials</h5>
        <ul class="social-icons">
          <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
        </ul>
      </div>

      <div class="col-sm-12 text-center">
  			<small>&copy; 2025 Crafttor. All rights reserved</small>
  		</div>
    </div>
  </div>
</footer>

<ng-template #letsTalk let-letsTalk>
    <div class="custom-dialog custom-dialog-centered sign-up" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="letsTalk.close()">
          </button>
        <div class="modal-body">
      <h2>Let's talk!</h2>
      <p>Schedule a free demo today. We will show you a demo of how Crafttor Workspace works.</p>
      <div class="form-wrapper">
        <form class="row g-3" [formGroup]="letsTalkForm" (ngSubmit)="submitContactUs(selectDate)">
          <div class="col-md-6">
          <label class="form-label">First Name<span>*</span></label>
          <input id="textinput" formControlName="name" type="text" placeholder="Brian" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.name.touched || submitted) && letsTalkForm.controls.name.errors?.required">
          First Name is required
        </span>
          </div>
          <div class="col-md-6">
          <label class="form-label">Last Name<span>*</span></label>
          <input id="textinput" formControlName="lname" type="text" placeholder="Storm" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.lname.touched || submitted) && letsTalkForm.controls.lname.errors?.required">
          Last Name is required
        </span>
          </div>
          <div class="col-12">
          <label for="businessEmail" class="form-label">Business Email<span>*</span></label>
          <input id="textinput" formControlName="email" type="email" placeholder="abc@crafttor.com" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.required">
          Email is required
        </span>
        <span class="text-danger error-text"
        *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.pattern">
        Email is not valid
      </span>
          </div>
          <div class="col-12">
          <label for="company" class="form-label">Company<span>*</span></label>
          <input id="textinput" formControlName="company" type="text" placeholder="Crafttor" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.company.touched || submitted) && letsTalkForm.controls.company.errors?.required">
          Company Name is required
        </span>
          </div>

          <div class="col-md-12" style="display: none;">
            <label class="form-label" for="textarea">Message</label>
            <input id="textinput" formControlName="message" type="text" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.message.touched || submitted) && letsTalkForm.controls.message.errors?.required">
            Message is required
          </span>
          </div>


          <div class="col-12">
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showLeaveLoader">Submit</button>
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
        </form>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>


<ng-template #selectDate let-selectDate>
    <div class="custom-dialog custom-dialog-centered select-time-popup" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="selectDate.close()">
          </button>
        <div class="modal-body">
      <h6>{{thankYouText}}</h6>
      <h6>(IST)</h6>
      <div class="form-wrapper">
        <ul class="date-listing" *ngFor="let slots of availableSlots | slice:1:5; let i = index">
          <li *ngIf="showDate">
            <div class="date-list" (click)="selectDateSales(slots.date, slots.day, slots.month)">
              <!-- <div class="date-list-day" style="background: #f9f9f9">
                <a href="javascript:;">{{slots.day}}</a>
              </div> -->
              <div class="">
                <a href="javascript:;">{{slots.month}} {{slots.date1}}</a>
              </div>
              <!-- <a href="javascript:;">{{slots.month}}</a> -->
            </div>
          </li>
        </ul>

        <div *ngIf="!showDate" class="selected-date">
          <div class="date-list-days">
            <a href="javascript:;">{{shownDay}}</a>
          </div>
          <div style="padding-top:10px;" class="">
            <a href="javascript:;">{{shownDate}}</a>
          </div>
          <!-- <a href="javascript:;">{{shownMonth}}</a> -->
        </div>

        <p *ngIf="!showDate" (click)="changeDate()" class="change-date-txt">Change Date</p>

        <h6 style="margin-top:20px;" *ngIf="showTime">What time works?</h6>

        <ul *ngFor="let time of availableTimeSlots; let i = index">
          <li *ngIf="showTime">
            <div class="time-list" (click)="selectTimeSales(time)">
              <div style="text-align: center;" class="">
                <a href="javascript:;">{{time}}</a>
              </div>
            </div>
          </li>
        </ul>
        <div *ngIf="showFinalTime" style="text-align: center;" class="selected-time">
          <a href="javascript:;">{{shownTime}}</a>
        </div>
        <p *ngIf="!showTime" (click)="changeTime()" class="change-time-txt"></p>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" (click)="contactSalesCall(thankyou); selectDate.close()" *ngIf="timeSelected && dateSelected && showSubmitBtn">Submit</button>
        <p *ngIf="showSelectionMessage" class="text-danger error-text" style="text-align: center; margin-top:10px; font-weight: 600">{{showSelectedMsg}}</p>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>

<ng-template #showloader let-showloader>
  <div class="custom-dialog custom-dialog-centered show-loader" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <img class="main-loader-img" style="margin-top: 200px; width: 180px;" src="assets/img/loader.svg" alt="">
        <h6 style="font-size: 16px;">Please wait</h6>
        <p>Confirming your meeting time..</p>
      </div>
  </div>
</div>
</ng-template>


<ng-template #thankyou let-thankyou>
  <div class="custom-dialog custom-dialog-centered thanks-popup" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h5>Thank you <br>Your meeting is confirmed. </h5>
          <div class="conver-grid">
            <div class="img-wrapper">
              <img src="" >
              <img src="assets/img/tick.png" class="tick">
            </div>
          <p>You are meeting with</p>
          <h4>Sandeep Virk</h4>
          </div>
      <div class="invitation-wrapper">
        <div class="">You will receive a meeting invitation shortly</div>
          <table>
          <tbody>
            <tr>
              <th>Event</th>
              <td>Crafttor intro with Sandeep</td>
            </tr>
            <!-- <tr>
              <th>Time</th>
              <td>Friday, Oct 22nd, 08:30PM - 9:00PM IST</td>
            </tr> -->
            <tr>
              <th>Guest</th>
              <td>{{userName}}<span><a>{{userEmail}}</a></span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <button id="singlebutton" name="singlebutton button" class="btn btn-primary" style="width: 100%;
    margin-top: 20px;" (click)="closeThankDialog()">Close</button>
    </div>
  </div>
</div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':sendingProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
		</div>
	</div>
</div>
